import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const calculateAge = (
  dob: string | null | undefined,
  today: Date = new Date()
): number | null => {
  if (!dob) return null
  const parsed = dayjs(dob, 'DD-MM-YYYY', true)
  if (!parsed.isValid()) return null
  const age = dayjs(today).diff(parsed, 'year')
  if (age < 0) return null
  return age
}
